"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.insert_grammar = void 0;
const errors_1 = require("../../errors");
const inspect_1 = require("../../utils/inspect");
const Value = __importStar(require("../../value"));
const Schedule = __importStar(require("../schedule"));
const Task = __importStar(require("../task"));
function insert_grammar(schedule, grammar, index) {
    if (grammar.kind === "Value.grammar") {
        const choices = Value.DelayedChoices.force(grammar.delayed);
        for (const [choice_name, parts] of choices) {
            Schedule.insert_task(schedule, Task.start(grammar.name, choice_name, parts, index));
        }
    }
    else {
        const token = schedule.tokens[index];
        const span = token.span;
        throw new errors_1.ParsingError("expecting grammar to be Value.grammar.\n" +
            `grammar: ${(0, inspect_1.inspect)(Value.present(grammar))}\n`, { span });
    }
}
exports.insert_grammar = insert_grammar;
//# sourceMappingURL=schedule-insert-grammar.js.map